export default ({ store, $trackPageView }) => {
  const campsite = store.state.campsite;

  // Only send page views to an enabled profile
  if (campsite.enabled) {
    $trackPageView({
      campsite_id: campsite._id.$oid,
    });
  }
};
